import { axiosWdw, axiosWdwCached, domainEndpoint } from './axios';

const endpoint = '/thought';

export default {
  get(params: any) {
    if (!params.fieldset) {
      params.fieldset = 'widget_list';
    }
    if (!params.status) {
      // default only fetch public thought in list
      // this is so pagination does not give us trouble, only public thoughts are displayed in thought-list
      params.status = 'show';
    }
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint,
      params: params,
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getItem(id: number, fieldset = 'default', permissions = 'basic') {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + '/' + id,
      params: { fieldset: fieldset, permissions: permissions },
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getVoteInfo(id: number) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + '/' + id,
      params: { fieldset: 'votes' },
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getCurrentVote(id: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + id + '/current_vote',
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getStatements(thoughtId: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + thoughtId + '/statement',
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  postVote(id: number, voteValue: number) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify({ vote: voteValue }));

      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint + '/' + id + '/vote',
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  postVoteComment(id: number, form: Record<string, any>, files: Map<string, any>) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify(form));

      files.forEach((value, key) => {
        formdata.append(key, value);
      });

      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint + '/' + id + '/comment_vote',
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getFollow(thoughtId: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + thoughtId + '/follow',
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  postFollow(thoughtId: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint + '/' + thoughtId + '/follow',
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteFollow(thoughtId: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'DELETE',
        url: domainEndpoint() + endpoint + '/' + thoughtId + '/follow',
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getSupportEmailContet(thoughtId: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + thoughtId + '/support_email_content',
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getFeedbackStatistics(id: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + id + '/feedback_statistics',
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPDF(id: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + id + '/download_pdf',
        responseType: 'blob',
      })
        .then(res => {
          if (res) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
